// pages/InvestPage.js
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Box, Typography, Button, TextField } from '@mui/material';

const InvestPage = ({ movies }) => {
  const { id } = useParams();
  const movieId = parseInt(id);

  // Find the movie by ID
  const movie = movies.find(movie => movie.id === movieId);

  // State for the number of units to invest in, starting at 0
  const [units, setUnits] = useState(0); // Changed from 1 to 0
  const unitPrice = 200; // Hardcoded unit price as per the image
  const totalInvestment = units * unitPrice; // Will be 0 when units is 0
  const freeTickets = units; // Will be 0 when units is 0

  if (!movie) {
    return <div>Movie not found</div>;
  }

  return (
    <Container
      maxWidth="lg"
      sx={{
        backgroundColor: '#1a1a1a',
        color: '#fff',
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      {/* Title */}
      <Typography variant="h5" component="h1" gutterBottom>
        Invest in {movie.name}
      </Typography>

      {/* Main Content: Image on the left, Data on the right */}
      <Box
        display="flex"
        flexDirection={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'center', md: 'flex-start' }}
        gap={3}
        marginBottom="20px"
      >
        {/* Movie Image */}
        <Box
          sx={{
            flex: '0 0 auto',
            width: { xs: '100%', md: '300px' },
            maxWidth: '300px',
          }}
        >
          <img
            src={movie.image}
            alt={movie.name}
            style={{
              width: '100%',
              height: 'auto',
              borderRadius: '10px',
              objectFit: 'cover',
            }}
          />
        </Box>

        {/* Investment Data */}
        <Box
          sx={{
            flex: 1,
            textAlign: 'left',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            marginTop: '40px',
          }}
        >
          <Typography variant="body1" gutterBottom>
            <strong>Current Funding:</strong> ₹{movie.currentFunding.toLocaleString()}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Target Funding:</strong> ₹{movie.targetFunding.toLocaleString()}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Unit Price:</strong> ₹{unitPrice}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Available Units:</strong> {movie.availableUnits.toLocaleString()}
          </Typography>

          {/* Investment Input Section */}
          <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            gap={2}
            marginTop="20px"
          >
            <Typography variant="body1">Number of Units:</Typography>
            <TextField
              type="number"
              value={units}
              onChange={(e) => setUnits(parseInt(e.target.value) || 0)} // Allow 0 as a valid value
              inputProps={{ min: 0, max: movie.availableUnits }} // Changed min from 1 to 0
              sx={{
                width: { xs: '100%', sm: '300px' },
                backgroundColor: '#fff',
                borderRadius: '5px',
              }}
            />
          </Box>

          {/* Total Investment */}
          <Typography variant="body1" sx={{ marginTop: '10px' }}>
            <strong>Total Investment:</strong> ₹{totalInvestment}
          </Typography>

          {/* Free Tickets */}
          <Typography variant="body2" gutterBottom sx={{ marginTop: '10px' }}>
            <strong>Free Tickets:</strong> {freeTickets}
          </Typography>

          {/* Invest Now Button */}
          <Button
            variant="contained"
            color="primary"
            sx={{
              marginTop: '20px',
              padding: '10px 20px',
              borderRadius: '5px',
              width: { xs: '100%', sm: 'auto' },
            }}
          >
            Invest Now
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default InvestPage;